import React from 'react';

import { useController, FieldValues } from 'react-hook-form';

import Box from '@mui/material/Box';
import Switch, { SwitchProps } from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';

import InfoIcon from '@mui/icons-material/InfoOutlined';

import { FormField } from '../types';

export type FormSwitchProps<TField extends FieldValues> = {
  label?: React.ReactNode;
  tooltip?: React.ReactNode;
} & FormField<TField> &
  SwitchProps;

const FormSwitch = <TField extends FieldValues>(props: FormSwitchProps<TField>) => {
  const { label, name, control, rules, defaultFormValue = false, sx, tooltip, ...checkBoxProps } = props;
  const { field } = useController({
    name,
    control,
    defaultValue: defaultFormValue,
    rules: {
      required: rules?.required,
    },
  });

  const { value, onChange, onBlur, ref } = field;

  return (
    <Box display="flex">
      <Box position="relative">
        <FormControlLabel
          sx={sx}
          control={
            <Switch color="primary" inputRef={ref} {...checkBoxProps} checked={value || defaultFormValue} onChange={onChange} onBlur={onBlur} />
          }
          label={label}
        />
        {tooltip && (
          <Tooltip title={tooltip} placement="bottom-end" sx={{ position: 'absolute', top: -4, right: -4 }}>
            <InfoIcon fontSize="small" />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default FormSwitch;
